import React from 'react';
import { CalendarClock } from 'lucide-react';

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }) : null);
export const telHref = (m) => `tel:${String(m || '').replace(/[^\d+]/g, '')}`;
export const prettyMobile = (m) => {
  const d = String(m || '').replace(/\D/g, '');
  return d.length === 10 && d.startsWith('04') ? `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}` : m;
};

export const STATE_STYLE = {
  pending: 'bg-slate-100 text-slate-600',
  done: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  skipped: 'bg-amber-50 text-amber-800 ring-1 ring-amber-200',
};

export const FLAG_LABEL = { esign: 'E-Sign open', idv: 'ID check open', docs: 'Docs outstanding' };

export const ApptBadge = ({ at, testId }) => (at ? (
  <span className="inline-flex items-center gap-1 rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-bold text-violet-700 ring-1 ring-violet-200" data-testid={testId}>
    <CalendarClock className="h-3 w-3" /> Appointment {fmtWhen(at)}
  </span>
) : null);
